export default __webpack_public_path__ + "static/media/r10.b1eccbd8.jpg";